/* text.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._313842dnbC%7Bmargin-top%3A0%7D%0A._0adFHsdnbC%7Bmargin-right%3A0%7D%0A._1DCdHidnbC%7Bmargin-bottom%3A0%7D%0A._2XsHFMdnbC%7Bmargin-left%3A0%7D%0A._3zvHkHdC7N%7Boverflow-wrap%3Aanywhere%7D%0A._1kk5Tkmb2E%7Bfont-weight%3Avar(--ds-font-weight-bold%2C653)%7D%0A._2l4i3rGpkd%7Bfont-style%3Aitalic%7D%0A._2fwxA5DIqT%7Btext-align%3Acenter%7D%0A._2fwxA5F05b%7Btext-align%3Aend%7D%0A._2fwxA57p2s%7Btext-align%3Astart%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._3iDTPbgJ9S%7Bdisplay%3A-webkit-box%7D%0A._1U1ZhbbI28%7B-webkit-box-orient%3Avertical%7D%0A._3W2Oc84hR5%7Bword-break%3Abreak-all%7D%0A._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._2sNsIg20Hp%7Bfont%3Avar(--ds-font-body-large%2Cnormal%20400%201pc%2F24px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._1UtDYzy7kJ%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D%0A._1UtDYzqsUt%7Bcolor%3Avar(--ds-text-accent-lime%2C%234c6b1f)%7D%0A._1UtDYzfXoY%7Bcolor%3Avar(--ds-text-accent-lime-bolder%2C%2337471f)%7D%0A._1UtDYzjgGB%7Bcolor%3Avar(--ds-text-accent-red%2C%23ae2e24)%7D%0A._1UtDYziNu3%7Bcolor%3Avar(--ds-text-accent-red-bolder%2C%235d1f1a)%7D%0A._1UtDYzu4OJ%7Bcolor%3Avar(--ds-text-accent-orange%2C%239e4c00)%7D%0A._1UtDYzH9Ub%7Bcolor%3Avar(--ds-text-accent-orange-bolder%2C%23693200)%7D%0A._1UtDYzDIkS%7Bcolor%3Avar(--ds-text-accent-yellow%2C%237f5f01)%7D%0A._1UtDYzD7aB%7Bcolor%3Avar(--ds-text-accent-yellow-bolder%2C%23533f04)%7D%0A._1UtDYz9qYF%7Bcolor%3Avar(--ds-text-accent-green%2C%23216e4e)%7D%0A._1UtDYzgGm3%7Bcolor%3Avar(--ds-text-accent-green-bolder%2C%23164b35)%7D%0A._1UtDYzY3Jz%7Bcolor%3Avar(--ds-text-accent-teal%2C%23206a83)%7D%0A._1UtDYz2SoF%7Bcolor%3Avar(--ds-text-accent-teal-bolder%2C%23164555)%7D%0A._1UtDYz866Z%7Bcolor%3Avar(--ds-text-accent-blue%2C%231558bc)%7D%0A._1UtDYz802h%7Bcolor%3Avar(--ds-text-accent-blue-bolder%2C%23123263)%7D%0A._1UtDYzYfD7%7Bcolor%3Avar(--ds-text-accent-purple%2C%23803fa5)%7D%0A._1UtDYzXCFT%7Bcolor%3Avar(--ds-text-accent-purple-bolder%2C%2348245d)%7D%0A._1UtDYzSbwp%7Bcolor%3Avar(--ds-text-accent-magenta%2C%23943d73)%7D%0A._1UtDYzcMOQ%7Bcolor%3Avar(--ds-text-accent-magenta-bolder%2C%2350253f)%7D%0A._1UtDYzUktF%7Bcolor%3Avar(--ds-text-accent-gray%2C%23505258)%7D%0A._1UtDYzyXux%7Bcolor%3Avar(--ds-text-accent-gray-bolder%2C%231e1f21)%7D%0A._1UtDYzot27%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D%0A._1UtDYze5R3%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._1UtDYzjTy9%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D%0A._1UtDYzGaer%7Bcolor%3Avar(--ds-text-brand%2C%231868db)%7D%0A._1UtDYzAyGJ%7Bcolor%3Avar(--ds-text-danger%2C%23ae2e24)%7D%0A._1UtDYzZSA9%7Bcolor%3Avar(--ds-text-warning%2C%239e4c00)%7D%0A._1UtDYzVW6T%7Bcolor%3Avar(--ds-text-warning-inverse%2C%23292a2e)%7D%0A._1UtDYzGL5O%7Bcolor%3Avar(--ds-text-success%2C%234c6b1f)%7D%0A._1UtDYzJejw%7Bcolor%3Avar(--ds-text-discovery%2C%23803fa5)%7D%0A._1UtDYzccV4%7Bcolor%3Avar(--ds-text-information%2C%231558bc)%7D%0A._1UtDYzKGUX%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D%0A._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._1UtDYzM7Tp%7Bcolor%3Avar(--ds-link%2C%231868db)%7D%0A._1UtDYzAwSC%7Bcolor%3Avar(--ds-link-pressed%2C%231558bc)%7D%0A._1UtDYzWfPD%7Bcolor%3Avar(--ds-link-visited%2C%23803fa5)%7D%0A._1UtDYzWyeI%7Bcolor%3Avar(--ds-link-visited-pressed%2C%2348245d)%7D%0A._1kk5Tkf7mX%7Bfont-weight%3Avar(--ds-font-weight-medium%2C500)%7D%0A._1kk5Tku7m9%7Bfont-weight%3Avar(--ds-font-weight-regular%2C400)%7D%0A._1kk5Tk7GSX%7Bfont-weight%3Avar(--ds-font-weight-semibold%2C600)%7D");

























































import { type ComponentPropsWithRef, type ElementType, forwardRef, type ReactNode, type Ref } from 'react';
import invariant from 'tiny-invariant';
import { type StrictXCSSProp } from '@atlaskit/css';
import { HasTextAncestorProvider } from '../../utils/has-text-ancestor-provider';
import { useSurface } from '../../utils/surface-provider';
import { useHasTextAncestor } from '../../utils/use-has-text-ancestor';
import type { BasePrimitiveProps, FontSize, FontWeight, TextAlign, TextColor } from './types';
const asAllowlist = (['span', 'p', 'strong', 'em'] as const);
type AsElement = (typeof asAllowlist)[number];
type TextPropsBase<T extends ElementType = 'span'> = {
  /**
   * HTML tag to be rendered. Defaults to `span`.
   */
  as?: AsElement;
  /**
   * Elements rendered within the Text element.
   */
  children: ReactNode;
  /**
   * Token representing text color with a built-in fallback value.
   * Will apply inverse text color automatically if placed within a Box with bold background color.
   * Defaults to `color.text` if not nested in other Text components.
   */
  color?: TextColor | 'inherit';
  /**
   * The [HTML `id` attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).
   */
  id?: string;
  /**
   * The number of lines to limit the provided text to. Text will be truncated with an ellipsis.
   *
   * When `maxLines={1}`, `wordBreak` defaults to `break-all` to match the behaviour of `text-overflow: ellipsis`.
   */
  maxLines?: number;
  /**
   * Text alignment.
   */
  align?: TextAlign;
  /**
   * Text size.
   */
  size?: FontSize;
  /**
   * The [HTML `font-weight` attribute](https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight).
   */
  weight?: FontWeight;
  /**
   * Bounded style overrides.
   */
  xcss?: StrictXCSSProp<'overflowWrap' | 'textDecorationLine' | 'fontVariantNumeric', never>;
  /**
   * Forwarded ref.
   */
  ref?: ComponentPropsWithRef<T>['ref'];
};
export type TextProps<T extends ElementType = 'span'> = TextPropsBase<T> & Omit<BasePrimitiveProps, 'xcss'>;

/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */
const useColor = (colorProp: TextColor | undefined | 'inherit', hasTextAncestor: boolean): TextColor | undefined => {
  const surface = useSurface();
  if (colorProp === 'inherit') {
    return undefined;
  }
  if (colorProp) {
    return colorProp;
  }
  if (hasTextAncestor) {
    return undefined;
  }
  if (inverseColorMap.hasOwnProperty(surface)) {
    return inverseColorMap[(surface as keyof typeof inverseColorMap)];
  }
  return 'color.text';
};
const styles = {
  root: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3zvHkHdC7N",
  'as.strong': "_1kk5Tkmb2E",
  'as.em': "_2l4i3rGpkd",
  'textAlign.center': "_2fwxA5DIqT",
  'textAlign.end': "_2fwxA5F05b",
  'textAlign.start': "_2fwxA57p2s",
  truncation: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbgJ9S _1U1ZhbbI28",
  breakAll: "_3W2Oc84hR5"
};
const fontSizeMap = {
  medium: "_2sNsIgmnOE",
  large: "_2sNsIg20Hp",
  small: "_2sNsIg7NXe"
};
const fontWeightMap = {
  bold: "_1kk5Tkmb2E",
  medium: "_1kk5Tkf7mX",
  regular: "_1kk5Tku7m9",
  semibold: "_1kk5Tk7GSX"
};
const textColorMap = {
  'color.text': "_1UtDYzy7kJ",
  'color.text.accent.lime': "_1UtDYzqsUt",
  'color.text.accent.lime.bolder': "_1UtDYzfXoY",
  'color.text.accent.red': "_1UtDYzjgGB",
  'color.text.accent.red.bolder': "_1UtDYziNu3",
  'color.text.accent.orange': "_1UtDYzu4OJ",
  'color.text.accent.orange.bolder': "_1UtDYzH9Ub",
  'color.text.accent.yellow': "_1UtDYzDIkS",
  'color.text.accent.yellow.bolder': "_1UtDYzD7aB",
  'color.text.accent.green': "_1UtDYz9qYF",
  'color.text.accent.green.bolder': "_1UtDYzgGm3",
  'color.text.accent.teal': "_1UtDYzY3Jz",
  'color.text.accent.teal.bolder': "_1UtDYz2SoF",
  'color.text.accent.blue': "_1UtDYz866Z",
  'color.text.accent.blue.bolder': "_1UtDYz802h",
  'color.text.accent.purple': "_1UtDYzYfD7",
  'color.text.accent.purple.bolder': "_1UtDYzXCFT",
  'color.text.accent.magenta': "_1UtDYzSbwp",
  'color.text.accent.magenta.bolder': "_1UtDYzcMOQ",
  'color.text.accent.gray': "_1UtDYzUktF",
  'color.text.accent.gray.bolder': "_1UtDYzyXux",
  'color.text.disabled': "_1UtDYzot27",
  'color.text.inverse': "_1UtDYze5R3",
  'color.text.selected': "_1UtDYzjTy9",
  'color.text.brand': "_1UtDYzGaer",
  'color.text.danger': "_1UtDYzAyGJ",
  'color.text.warning': "_1UtDYzZSA9",
  'color.text.warning.inverse': "_1UtDYzVW6T",
  'color.text.success': "_1UtDYzGL5O",
  'color.text.discovery': "_1UtDYzJejw",
  'color.text.information': "_1UtDYzccV4",
  'color.text.subtlest': "_1UtDYzKGUX",
  'color.text.subtle': "_1UtDYzZpcK",
  'color.link': "_1UtDYzM7Tp",
  'color.link.pressed': "_1UtDYzAwSC",
  'color.link.visited': "_1UtDYzWfPD",
  'color.link.visited.pressed': "_1UtDYzWyeI"
};
const inverseColorMap = ({
  'color.background.neutral.bold': 'color.text.inverse',
  'color.background.neutral.bold.hovered': 'color.text.inverse',
  'color.background.neutral.bold.pressed': 'color.text.inverse',
  'color.background.selected.bold': 'color.text.inverse',
  'color.background.selected.bold.hovered': 'color.text.inverse',
  'color.background.selected.bold.pressed': 'color.text.inverse',
  'color.background.brand.bold': 'color.text.inverse',
  'color.background.brand.bold.hovered': 'color.text.inverse',
  'color.background.brand.bold.pressed': 'color.text.inverse',
  'color.background.brand.boldest': 'color.text.inverse',
  'color.background.brand.boldest.hovered': 'color.text.inverse',
  'color.background.brand.boldest.pressed': 'color.text.inverse',
  'color.background.danger.bold': 'color.text.inverse',
  'color.background.danger.bold.hovered': 'color.text.inverse',
  'color.background.danger.bold.pressed': 'color.text.inverse',
  'color.background.warning.bold': 'color.text.warning.inverse',
  'color.background.warning.bold.hovered': 'color.text.warning.inverse',
  'color.background.warning.bold.pressed': 'color.text.warning.inverse',
  'color.background.success.bold': 'color.text.inverse',
  'color.background.success.bold.hovered': 'color.text.inverse',
  'color.background.success.bold.pressed': 'color.text.inverse',
  'color.background.discovery.bold': 'color.text.inverse',
  'color.background.discovery.bold.hovered': 'color.text.inverse',
  'color.background.discovery.bold.pressed': 'color.text.inverse',
  'color.background.information.bold': 'color.text.inverse',
  'color.background.information.bold.hovered': 'color.text.inverse',
  'color.background.information.bold.pressed': 'color.text.inverse'
} as const);

/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */
export const Text: React.ForwardRefExoticComponent<React.PropsWithoutRef<TextProps<ElementType>> & React.RefAttributes<any>> = forwardRef(<T extends ElementType = 'span',>({
  as: Component = 'span',
  color: colorProp,
  align,
  testId,
  id,
  size,
  weight,
  maxLines,
  xcss,
  children
}: TextProps<T>, ref: Ref<any>) => {
  invariant(asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
  const hasTextAncestor = useHasTextAncestor();
  const color = useColor(colorProp, hasTextAncestor);
  if (!size && !hasTextAncestor) {
    size = 'medium';
  }
  const component = <Component id={id} className={ax([styles.root, size && fontSizeMap[size], color && textColorMap[color], maxLines && styles.truncation, maxLines === 1 && styles.breakAll, align && styles[`textAlign.${align}`], weight && fontWeightMap[weight], Component === 'em' && styles['as.em'], Component === 'strong' && styles['as.strong'], xcss])} style={{
    WebkitLineClamp: maxLines
  }} data-testid={testId} ref={ref}>
				{children}
			</Component>;
  if (hasTextAncestor) {
    // no need to re-apply context if the text is already wrapped
    return component;
  }
  return <HasTextAncestorProvider value={true}>{component}</HasTextAncestorProvider>;
});